<template>
	<div class="my-order" ref="container">
		<div class="header bg-color-red">
			<div class="picTxt acea-row row-between-wrapper">
				<div class="text">
					<div class="name">订单信息</div>
					<div>
						累计订单：{{ orderData.order_count || 0 }} 总消费：￥{{
              orderData.sum_price || 0
            }}
					</div>
				</div>
				<div class="pictrue"><img src="@assets/images/orderTime.png" /></div>
			</div>
		</div>
		<!-- 		<div class="nav acea-row row-around" v-if="order.judge_status!=0">
			<div class="item" :class="{ on: order.judge_status==1 }" @click="$router.replace({ path: '/order/list/0' })">
				<div>医师开方</div>
				<div class="num">{{ orderData.unpaid_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: order.judge_status === 2 }" @click="$router.replace({ path: '/order/list/1' })">
				<div>医师审方</div>
				<div class="num">{{ orderData.unshipped_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: order.judge_status === 3 && type === 2 }" @click="$router.replace({ path: '/order/list/2' })">
				<div>待付款</div>
				<div class="num">{{ orderData.received_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 3 }" @click="$router.replace({ path: '/order/list/3' })">
				<div>待收货</div>
				<div class="num">{{ orderData.evaluated_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 4 }" @click="$router.replace({ path: '/order/list/4' })">
				<div>已完成</div>
				<div class="num">{{ orderData.complete_count || 0 }}</div>
			</div>
		</div> -->
		<div class="nav acea-row row-around" style="height: 1rem;margin-top: -0.8rem;">
			<div class="item" :class="{ ontype: ordertype == 0 }" @click="getordertype(0)"
				style="border:2px solid #00C14C;border-radius: 10px;line-height: .65rem;padding: 0 0.7rem;margin: 0.15rem 0px;position:relative;">
				<div>
					商城订单
					<span class="order-status-num" v-if="allCount0 != 0">{{
            allCount0
          }}</span>
				</div>
			</div>
			<div class="item" :class="{ ontype: ordertype == 1 }" @click="getordertype(1)"
				style="border:2px solid #00C14C;border-radius: 10px;line-height: .65rem;padding: 0 0.7rem;margin: 0.15rem 0px;position:relative;">
				<div>处方订单</div>
				<span class="order-status-num" v-if="allCount1 != 0">{{
          allCount1
        }}</span>
			</div>
		</div>
		<div class="nav acea-row row-around" style="margin-top:0;">
			<div class="item" :class="{ on: type === 0 }" @click="typeswitch(0)">
				<div>待付款</div>
				<div class="num">{{ orderData.unpaid_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 1 }" @click="typeswitch(1)">
				<div>待发货</div>
				<div class="num">{{ orderData.unshipped_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 2 }" @click="typeswitch(2)">
				<div>待收货</div>
				<div class="num">{{ orderData.received_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 3 }" @click="typeswitch(3)">
				<div>待评价</div>
				<div class="num">{{ orderData.evaluated_count || 0 }}</div>
			</div>
			<div class="item" :class="{ on: type === 4 }" @click="typeswitch(4)">
				<div>已完成</div>
				<div class="num">{{ orderData.complete_count || 0 }}</div>
			</div>
		</div>
		<div class="list">
			<div class="item" v-for="order in orderList" :key="order.id">
				<div class="title acea-row row-between-wrapper">
					<div class="acea-row row-middle">
						<span class="sign cart-color acea-row row-center-wrapper"
							v-if="order.combination_id > 0">拼团</span><span
							class="sign cart-color acea-row row-center-wrapper"
							v-if="order.seckill_id > 0">秒杀</span><span
							class="sign cart-color acea-row row-center-wrapper" v-if="order.bargain_id > 0">砍价</span>
						{{ order._add_time }}{{ order.judge_status }}
					</div>
					<div class="font-color-red" v-if="
              order.is_judge == 1 &&
                (order.judge_status >= 0 || order.judge_status >= 5) &&
                order.judge_status != 4
            ">
						<div v-if="order.judge_status == 0 && order.paid == 0">待付款</div>
						<div v-if="order.judge_status == 0 && order.paid == 1">待开方</div>
						<div v-if="order.judge_status == 1 || order.judge_status == 2">
							审方中
						</div>
						<div v-if="order.judge_status == 3 || order.judge_status == 5" style="color:red">
							审方失败
						</div>
						<!-- <div v-if="order.judge_status == 4">待发货</div> -->
					</div>
					<div class="font-color-red" v-else>{{ getStatus(order) }}</div>
				</div>
				<div @click="$router.push({ path: '/order/detail/' + order.order_id })">
					<div class="item-info acea-row row-between row-top" v-for="cart in order.cartInfo" :key="cart.id">
						<div class="pictrue">
							<img :src="cart.productInfo.image" @click.stop="
                  $router.push({ path: '/detail/' + cart.productInfo.id })
                " v-if="
                  cart.combination_id === 0 &&
                    cart.bargain_id === 0 &&
                    cart.seckill_id === 0
                " />
							<img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/group_detail/' + cart.combination_id
                  })
                " v-else-if="cart.combination_id > 0" />
							<img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/dargain_detail/' + cart.bargain_id
                  })
                " v-else-if="cart.bargain_id > 0" />
							<img :src="cart.productInfo.image" @click.stop="
                  $router.push({
                    path: '/activity/seckill_detail/' + cart.seckill_id
                  })
                " v-else-if="cart.seckill_id > 0" />
						</div>
						<div class="text acea-row row-between">
							<div class="name line2">
								{{ cart.productInfo.store_name }}
							</div>
							<div class="money">
								<div>
									￥{{
                    cart.productInfo.attrInfo
                      ? cart.productInfo.attrInfo.price
                      : cart.productInfo.price
                  }}
								</div>
								<div>x{{ cart.cart_num }}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="totalPrice">
					共{{ order.cartInfo.length || 0 }}件商品，总金额
					<span class="money font-color-red">￥{{ order.pay_price }}</span>
				</div>
				<div class="bottom acea-row row-right row-middle">
					<!-- 					<template>
						<div class="bnt bg-color-red">
							<a :href="'tel:' + (order.merchant_tell || '')" class="bnt cancel">
							联系商家</a>
						</div>
					</template> -->
					<template v-if="order._status._type === 0">
						<div class="bnt cancelBnt" @click="cancelOrder(order)">
							取消订单
						</div>
						<div class="bnt bg-color-red" @click="nopay" v-if="order.judge_status == 1">
							立即付款
						</div>
						<div class="bnt bg-color-red" @click="paymentTap(order)" v-else>
							立即付款
						</div>
					</template>
					<template v-if="order._status._type === 1 || order._status._type === 9">
						<div class="bnt bg-color-red"
							@click="$router.push({ path: '/order/detail/' + order.order_id })">
							查看详情
						</div>
					</template>
					<!-- <template v-if="order._status._type >= 1&&order.is_judge == 1 && order.judge_status == 4">
						<div class="bnt bg-color-red" style="width: auto;padding: 0 3%;">
							<a :href="order.rpUrl" class="bnt cancel">查看并下载处方</a>
						</div>
					</template> -->
					<template v-if="
              order._status._type === 2 &&
                (order.shipping_type != 3 && order.shipping_type != 4)
            ">
						<div class="bnt default" @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              ">
							查看物流
						</div>
						<div class="bnt bg-color-red" @click="takeOrder(order)">
							确认收货
						</div>
					</template>
					<template v-if="
              order._status._type === 2 &&
                (order.shipping_type == 3 || order.shipping_type == 4)
            ">
						<div class="bnt bg-color-red" @click="lookWei(order.order_id)">
							骑手位置
						</div>
						<div class="bnt bg-color-red" @click="callPhone(order.order_id)">
							联系骑手
						</div>
						<div class="bnt bg-color-red" @click="callPhone2(order.merchant_tell)">
							联系商家
						</div>
						<div class="bnt bg-color-red" @click="takeOrder(order)">
							确认收货
						</div>
					</template>
					<template v-if="order._status._type === 3">
						<div class="bnt default" @click="
                $router.push({ path: '/order/logistics/' + order.order_id })
              " v-if="order.delivery_type === 'express'">
							查看物流
						</div>
						<div class="bnt bg-color-red"
							@click="$router.push({ path: '/order/detail/' + order.order_id })">
							去评价
						</div>
					</template>
					<template v-if="order._status._type === 4">
						<div class="bnt bg-color-red"
							@click="$router.push({ path: '/order/detail/' + order.order_id })">
							查看订单
						</div>
						<!-- <div class="bnt bg-color-red" @click="$router.push({ path: '/cart/list/' + order.order_id })">
							再来一单
						</div> -->
					</template>
				</div>
			</div>
		</div>
		<div class="noCart" v-if="orderList.length === 0 && page > 1">
			<div class="pictrue"><img src="@assets/images/noOrder.png" /></div>
		</div>
		<Loading :loaded="loaded" :loading="loading"></Loading>
		<Payment v-model="pay" :types="payType" @checked="toPay" :balance="userInfo.now_money" :paytype="shipping_type">
		</Payment>
	</div>
</template>
<script>
	import {
		getOrderData,
		getOrderList
	} from "@api/order";
	import {
		cancelOrderHandle,
		payOrderHandle,
		takeOrderHandle
	} from "@libs/order";
	import Loading from "@components/Loading";
	import Payment from "@components/Payment";
	import {
		mapGetters
	} from "vuex";
	import {
		isWeixin
	} from "@utils";
	import axios from "axios";

	const STATUS = [
		"待付款",
		"待发货",
		"待收货",
		"待评价",
		"已完成",
		"",
		"",
		"",
		"",
		"待付款"
	];

	const NAME = "MyOrder";

	export default {
		name: NAME,
		data() {
			const {
				ordertype = 0
			} = this.$route.query;
			return {
				offlinePayStatus: 2,
				orderData: {},
				type: parseInt(this.$route.params.type) || 0,
				page: 1,
				limit: 20,
				loaded: false,
				loading: false,
				orderList: [],
				pay: false,
				ordertype: ordertype,
				payType: ["yue", "weixin"],
				from: isWeixin() ? "weixin" : "weixinh5",
				shipping_type: "",
				allCount0: 0,
				allCount1: 0
			};
		},
		components: {
			Loading,
			Payment
		},
		computed: mapGetters(["userInfo"]),
		watch: {
			$route(n) {
				if (n.name === NAME) {
					const type = parseInt(this.$route.params.type) || 0;
					if (this.type !== type) {
						this.changeType(type);
					}
					this.getOrderData();
				}
			}
		},
		methods: {
			getLists() {
				console.log(123);
				var id = "wx1234567899";
				axios
					.post(
						"https://app.funengtuan.com/api/meituan/delivery_get_order_info/" + id
					)
					.then(function(response) {
						console.log(response);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			// 查看骑手位置
			lookWei(a) {
				console.log(123123123);
				window.location.href =
					"https://app.funengtuan.com/map.html?ordersid=" + a;
			},
			// 拨打电话
			callPhone(id) {
				let that = this;
				axios
					.post(
						"https://app.funengtuan.com/api/meituan/delivery_get_order_info/" + id
					)
					.then(function(response) {
						console.log(response);
						if (response.data.data.data.courier_phone) {
							window.location.href =
								"tel://" + response.data.data.data.courier_phone;
						} else {
							return that.$dialog.toast({
								mes: "暂无骑手哦"
							});
						}
					})
					.catch(function(error) {
						console.log(error);
					});
				// var a = Math.floor(Math.random() * 10); //可均衡获取0到9的随机整数。
				// var b = [
				//   "17735188818",
				//   "19935343434",
				//   "19903518288",
				//   "19903518118",
				//   "17735188816",
				//   "19935343435",
				//   "19903518284",
				//   "19903518113",
				//   "17735188812",
				//   "19935343431"
				// ];
				// var c = b[a];
				// window.location.href = "tel://" + c;
			},
			callPhone2(tel) {
				window.location.href = "tel://" + tel;
			},
			typeswitch: function(switchtype) {
				if (switchtype == this.type) {
					return false;
				}
				this.type = switchtype;
				this.changeType(switchtype);
				this.getOrderData();
				this.getOrderDas(0);
				this.getOrderDas(1);
			},
			getordertype: function(ordertype) {
				if (ordertype == this.ordertype) {
					return false;
				}
				this.ordertype = ordertype;
				// this.type = this.type;
				this.changeType(this.type);
				this.getOrderData();
			},
			nopay: function() {
				return this.$dialog.toast({
					mes: "请耐心等待医师开方"
				});
			},
			setOfflinePayStatus: function(status) {
				var that = this;
				that.offlinePayStatus = status;
				if (status === 1) {
					if (that.payType.indexOf("offline") < 0) {
						that.payType.push("offline");
					}
				}
			},
			getOrderData() {
				const {
					ordertype
				} = this;
				getOrderData(ordertype).then(res => {
					this.orderData = res.data;
				});
			},
			getOrderDas(a) {
				console.log(this.type);
				getOrderData(a).then(res => {
					if (a == 0) {
						if (this.type == 0) {
							this.allCount0 = res.data.unpaid_count;
						} else if (this.type == 1) {
							this.allCount0 = res.data.unshipped_count;
						} else if (this.type == 2) {
							this.allCount0 = res.data.received_count;
						} else if (this.type == 3) {
							this.allCount0 = res.data.evaluated_count;
						} else {
							this.allCount0 =
								res.data.complete_count +
								res.data.evaluated_count +
								res.data.received_count +
								res.data.unpaid_count +
								res.data.unshipped_count;
						}
					} else {
						if (this.type == 0) {
							this.allCount1 = res.data.unpaid_count;
						} else if (this.type == 1) {
							this.allCount1 = res.data.unshipped_count;
						} else if (this.type == 2) {
							this.allCount1 = res.data.received_count;
						} else if (this.type == 3) {
							this.allCount1 = res.data.evaluated_count;
						} else {
							this.allCount1 =
								res.data.complete_count +
								res.data.evaluated_count +
								res.data.received_count +
								res.data.unpaid_count +
								res.data.unshipped_count;
						}
					}
				});
			},
			takeOrder(order) {
				takeOrderHandle(order.order_id).finally(() => {
					this.reload();
					this.getOrderData();
				});
			},
			reload() {
				this.changeType(this.type);
			},
			changeType(type) {
				this.type = type;
				this.orderList = [];
				this.page = 1;
				this.loaded = false;
				this.loading = false;
				this.getOrderList();
			},
			getOrderList() {
				if (this.loading || this.loaded) return;
				this.loading = true;
				const {
					page,
					limit,
					type,
					ordertype
				} = this;
				// console.log(ordertype)
				getOrderList({
					page,
					limit,
					type,
					ordertype
				}).then(res => {
					this.orderList = this.orderList.concat(res.data);
					this.page++;
					this.loaded = res.data.length < this.limit;
					this.loading = false;
				});
			},
			getStatus(order) {
				return STATUS[order._status._type];
			},
			cancelOrder(order) {
				cancelOrderHandle(order.order_id)
					.then(() => {
						this.orderList.splice(this.orderList.indexOf(order), 1);
					})
					.catch(() => {
						this.reload();
					});
			},
			paymentTap: function(order) {
				this.shipping_type = order.shipping_type;
				var that = this;
				if (order.is_judge == 1) {
					window.location.href =
						"http://sifei.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=vip";
					// window.location.href = "http://wx.dxkyyy.com/api/integral_auth?orders_sn=" + data.result.orderId +
					// 	"&back_url=" + window.location.host + '&pay_type=vip';
					return;
				}
				if (order.member_shop == 1) {
					// 积分商城支付
					window.location.href =
						"http://qqhy.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=integral";
					return;
				}
				if (order.cloud_mid !== 0) {
					// 云药库支付
					window.location.href =
						"http://xlx.funengtuan.com/api/integral_auth?orders_sn=" +
						order.order_id +
						"&back_url=" +
						window.location.host +
						"/order/list/0" +
						"&pay_type=integral";
					return;
				}
				if (
					!(
						order.combination_id > 0 ||
						order.bargain_id > 0 ||
						order.seckill_id > 0
					)
				) {
					that.setOfflinePayStatus(order.offlinePayStatus);
				}
				this.pay = true;
				this.toPay = type => {
					payOrderHandle(order.order_id, type, that.from)
						.then(() => {
							const type = parseInt(this.$route.params.type) || 0;
							that.changeType(type);
							that.getOrderData();
						})
						.catch(() => {
							const type = parseInt(that.$route.params.type) || 0;
							that.changeType(type);
							that.getOrderData();
						});
				};
			},
			toPay() {}
		},
		mounted() {
			this.getLists();
			this.getOrderData();
			// type: parseInt(this.$route.params.type) || 0,
			this.getOrderDas(0);
			this.getOrderDas(1);
			this.getOrderList();
			this.$scroll(this.$refs.container, () => {
				!this.loading && this.getOrderList();
			});
		}
	};
</script>

<style scoped>
	.order-status-num {
		height: 0.33rem;
		line-height: 0.33rem;
		background-color: #fff;
		color: red;
		border-radius: 15px;
		position: absolute;
		right: -0.14rem;
		top: -0.15rem;
		font-size: 0.2rem;
		padding: 0 0.08rem;
		border: 1px solid red;
	}

	.my-order .list .item .bottom .bnt {
		width: 22% !important;
	}

	.ontype {
		background: #00c14c;
		color: #fff !important;
	}

	.noCart {
		margin-top: 0.17rem;
		padding-top: 0.1rem;
	}

	.noCart .pictrue {
		width: 4rem;
		height: 3rem;
		margin: 0.7rem auto 0.5rem auto;
	}

	.noCart .pictrue img {
		width: 100%;
		height: 100%;
	}
</style>
